import { RandomGenerator } from '../../../test-utils';
import { PluginType } from './plugin-type.enum';
var TwitterAccountDataBuilder = /** @class */ (function () {
    function TwitterAccountDataBuilder() {
        this.twitterPlugin = {
            account: {
                externalKey: RandomGenerator.randomId(),
                name: RandomGenerator.randomString(),
                creationDate: Date.now(),
                lastUpdateDate: Date.now(),
                type: PluginType.TWITTER_ACCOUNT,
                data: {
                    directMessageEnabled: true,
                    mentionEnabled: true,
                    profileImage: ''
                }
            },
            valid: false
        };
    }
    TwitterAccountDataBuilder.prototype.withExternalKey = function (externalKey) {
        this.twitterPlugin.account.externalKey = externalKey;
        return this;
    };
    TwitterAccountDataBuilder.prototype.withName = function (name) {
        this.twitterPlugin.account.name = name;
        return this;
    };
    TwitterAccountDataBuilder.prototype.withCreationDate = function (date) {
        this.twitterPlugin.account.creationDate = date;
        return this;
    };
    TwitterAccountDataBuilder.prototype.withLastUpdateDate = function (date) {
        this.twitterPlugin.account.lastUpdateDate = date;
        return this;
    };
    TwitterAccountDataBuilder.prototype.withType = function (type) {
        this.twitterPlugin.account.type = type;
        return this;
    };
    TwitterAccountDataBuilder.prototype.withData = function (data) {
        this.twitterPlugin.account.data = data;
        return this;
    };
    TwitterAccountDataBuilder.prototype.withValid = function (valid) {
        this.twitterPlugin.valid = valid;
        return this;
    };
    TwitterAccountDataBuilder.prototype.build = function () {
        return this.twitterPlugin;
    };
    return TwitterAccountDataBuilder;
}());
export { TwitterAccountDataBuilder };
;
//# sourceMappingURL=twitter-account-plugin-builder.js.map